import React, {Fragment, useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import WebIcon from '@material-ui/icons/Web';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import WorkIcon from '@material-ui/icons/Work';
import PersonIcon from '@material-ui/icons/Person';
import MouseIcon from '@material-ui/icons/Mouse';
import SendIcon from '@material-ui/icons/Send';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ReplyIcon from '@material-ui/icons/Reply';
import SearchIcon from '@material-ui/icons/Search';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ShortTextIcon from '@material-ui/icons/ShortText';
import {List, Popup, Select, Search, Popover, GridList, PlusButton, Folder_system,Card} from '../../../../components';
import {connect} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme=>({
  top_bar:{
    width:'100vw',
    marginLeft:'-10px',
    ['@media (min-width:600px)']:{
      width:'calc(100vw - 60px)',
      marginLeft:'-20px'
    },
  }
}));


function Clone_popup(props){

  function onClone(id){
    props.cloneShortCode(id);
    props.handleClose();
  }

  return(
    <Popup always_open title={'Clone short code'} accept_button='Clone' handleClose={props.handleClose} accept_button_click={()=>{onClone(props.short_code.id);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{"Are you sure you want to clone this short code?"}</Typography></div>
      </div>
    }/>
  )
}




function Delete_popup(props){


  function onDelete(id){
    props.deleteShortCode(id);
    props.handleClose();
  }

  return(
    <Popup always_open title={'Delete short code'} accept_button='Delete' handleClose={props.handleClose} accept_button_click={()=>{onDelete(props.short_code.id);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{"Are you sure you want to permanently delete the '"+props.short_code.unique_code+"' short_code? This action can not be undone."}</Typography></div>
      </div>
    }/>
  )
}

function Shared(props){
  if(props.share==true){
    return(<Tooltip title={'Workspace template'} aria-label="add"><WorkIcon {...props}/></Tooltip>)
  }else{
    return(<Tooltip title={'Personal template'} aria-label="add"><PersonIcon {...props}/></Tooltip>)
  }
}

function ShortCodesSection(props){
  const[search, setSearch]=useState('');
  const[filter, setFilter]=useState('all');
  const[delete_popup, setDeletePopup]=useState(undefined);
  const[clone_popup, setClonePopup]=useState(undefined);
  const[current_folder_id, setCurrentFolderId]=useState(undefined);


  let classes=useStyles();

  useEffect(()=>{
    if(props.short_codes==undefined){props.indexShortCodes();}
  },[])

  //<Shared share={x.workspace_share} color='primary' style={{position:'absolute', right:'60px', top:'-1px'}}/><EditIcon style={{position:'absolute', right:'30px', top:'-1px'}} onClick={()=>{props.history.push('/email/templates/'+x.id+'/edit')}}/><DeleteIcon color='error' style={{position:'absolute', right:'5px', top:'-1px'}} onClick={()=>{setDeletePopup(x);}}/>
  let short_codes=[]; if(props.short_codes!=undefined){for(let key in props.short_codes){let name=props.short_codes[key].name.toLowerCase(); let text=props.short_codes[key].text.toLowerCase(); if(search=='' || name.includes(search.toLowerCase()) || text.includes(search.toLowerCase())){short_codes.push(props.short_codes[key])}}}

  return(
    <div style={{marginTop:'60px'}}>
      <PlusButton current_folder_id={current_folder_id} folder_type="SHORT_CODES"  color='primary' options={[{label:'Short Code', icon:<ShortTextIcon/>, action:()=>{props.history.push('/email/shortCodes/new')}}]}/>
    <div className={classes.top_bar} style={{boxShadow:'1px 1px 4px #888888', position:'relative', paddingTop:'12px', paddingBottom:'2px', zIndex:'3'}}>
    <Grid container>
      <Grid item xs={12} sm={6} md={4}><div style={{width:'calc(100% - 60px)', marginLeft:'30px'}}><TextField type='name' InputProps={{startAdornment:<SearchIcon/>}} variant='outlined' size='small' label='Search' value={search} onChange={(e)=>{setSearch(e.target.value)}} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'5px', marginBottom:'5px', backgroundColor:'#f7f9fc'}}/></div></Grid>
    </Grid>
    </div>
    <div style={{width:'100%', height:'calc(100vh - 125px)'}}>
    <Folder_system folder_type="SHORT_CODES" resources={short_codes} updateResource={props.updateShortCode} setCurrentFolderId={setCurrentFolderId} displayResources={(short_codes) => {
      console.log(short_codes, 'WOW RESOURCESSSSS');
      return (
    <GridList list_items={short_codes} rowHeight={130} responsive_columns={{0:1, 720:2, 1000:3, 1300:4}} component={(x)=>{
      if(x.deleted_at==null && ((filter=='personal_only' && x.user_id==props.me.id) || (filter=='workspace_only' && x.workspace_share==true) || filter=='all')){
        let options_list=[{id:2, icon:<FileCopyIcon color='primary'/>, main_text:'Clone'}]
        if((props.workspace!=undefined && props.workspace.admin==true) || props.me.id==x.user_id){options_list.push({id:5, icon:<EditIcon color='primary'/>, main_text:'Edit'}); options_list.push({id:4, icon:<DeleteIcon color='error'/>, main_text:'Delete'});}

      return(
        <Card id={x.id} key={x.id} index={x.id} text={
        <div style={{height:'100%', width:'100%', position:'relative', marginTop:'20px'}}>{
          <Paper style={{overflowX:'hidden', overflowY:'hidden', height:'110px', width:'calc(100% - 40px)', marginLeft:'20px', position:'relative'}}>
            <div style={{boxShadow:'1px 1px 4px #888888', position:'relative', zIndex:'2', marginTop:'-10px', paddingTop:'8px'}}><Typography color='primary' style={{marginLeft:'30px', marginTop:'5px', marginBottom:'5px'}}>{(x.workspace_share==true)?<Tooltip title='Available to workspace'><WorkIcon style={{position:'absolute', left:'5px', top:'11px', width:'20px'}}/></Tooltip>:<Tooltip title='Personal template'><PersonIcon style={{position:'absolute', left:'5px', top:'11px', width:'20px'}}/></Tooltip>}{x.name+' ('+x.unique_code+')'}<Popover style={{position:'absolute', right:'0px'}} trigger={<MoreVertIcon color='primary' style={{position:'absolute', right:'0px', top:'0px', cursor:'pointer'}}/>} content={
              <div style={{width:'140px'}}>
              <List onClick={(item)=>{if(item.id==5){props.history.push('/email/shortCodes/'+x.id+'/edit');}else if(item.id==4){setDeletePopup(x);}else if(item.id==2){setClonePopup(x);}else{console.log(item);}}} list_data={options_list}/>
              </div>
            }/></Typography></div>
            <div style={{height:'calc(100% - 30px)', position:'relative', overflowY:'scroll', zIndex:'1', marginTop:'-3px'}}><Typography variant='caption'><div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'2px', marginBottom:'0px'}} dangerouslySetInnerHTML={{__html:x.text}}></div></Typography></div>
          </Paper>
        }</div>}/>
      )
    }else{return null;}}}
    />
  )}}/>
    </div>
    {(clone_popup!=undefined)?<Clone_popup {...props} short_code={clone_popup} handleClose={()=>{setClonePopup(undefined)}}/>:null}
    {(delete_popup!=undefined)?<Delete_popup {...props} short_code={delete_popup} handleClose={()=>{setDeletePopup(undefined)}}/>:null}
    </div>
  );
}

export default connect(ss,dd)(ShortCodesSection);


function ss(state){
  return{
    me:state.account.me,
    short_codes:state.templates.short_codes,
    refresh:state.templates.refresh
  }
}

function dd(dispatch){
  return{
    updateShortCode: (id, data) => { dispatch({ type: 'REQUEST_UPDATE_SHORT_CODE', id: id, payload: data }) },
    cloneShortCode:(id)=>{dispatch({type:'REQUEST_CLONE_SHORT_CODE', id:id})},
    deleteShortCode:(id)=>{dispatch({type:'REQUEST_DELETE_SHORT_CODE', id:id});},
    indexShortCodes:()=>{dispatch({type:'REQUEST_INDEX_SHORT_CODES'});}
  }
}
